import React, { useContext } from 'react';
import { Link, Route, Routes,Navigate ,useParams} from 'react-router-dom';
import './App.css';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import { CartContext } from './context/CartContext';
import CheckoutPageSuccess from "./pages/CheckoutPageSuccess";
import TrackOrder from './pages/TrackOrder';
import ProductDetails from './components/ProductDetails';
import ContactUs from "./pages/ContactUs";
import AboutUs from "./pages/AboutUs";
import Shop from "./pages/Shop";
import Homepage from './pages/Homepage';
import CategoryPage from "./pages/CategoryPage";
import {HelmetProvider} from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import BookAppointment from "./components/BookAppointment";
import Faq from './pages/Faq'
import MechanicsPage from './pages/MechanicsPage';
import VehicleDetailsPage from './pages/VehicleDetailsPage';
import CarRentalPage from './pages/CarRentalPage';
import CarServicePage from './pages/CarServicePage';
import CarImportationPage from './pages/CarImportationPage';
import TermsAndConditions from './pages/TermsAndConditions';
import WorkWithUsPage from './pages/WorkWithUsPage';
import ArticlesPage from './pages/ArticlesPage';
import ArticlesDetailsPage from './pages/ArticlesDetailsPage';

const PageNotFound = () => (
  <div style={{ textAlign: 'center', marginTop: '50px' }}>
    <h1>404 - Page Not Found</h1>
    <p>The page you are looking for does not exist.</p>
    <Link to="/" style={{ color: 'blue', textDecoration: 'underline' }}>
      Go back to Home
    </Link>
  </div>
);



function App() {

  return (
    <div className="container mx-auto">
      
      <Header/>
      
      <BookAppointment /> 

      <main>
      <HelmetProvider>
      <ScrollToTop /> 

        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/faq" element={<Faq/>}/>
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/mechanics" element={<MechanicsPage/>}/>
          <Route path="/car-rentals" element={<CarRentalPage/>}/>
          <Route path="/car-servicing" element={<CarServicePage/>}/>
          <Route path="/work-with-us" element={<WorkWithUsPage/>}/>
          <Route path="/articles/:slug" element={<ArticlesDetailsPage/>}/>
          <Route path="/articles" element={<ArticlesPage/>}/>
          <Route path="/car-importation-consultation" element={<CarImportationPage/>}/>
          <Route path="/terms-and-conditions" element={<TermsAndConditions/>}/>
          <Route path="/collections/:slug" element={<CategoryPage />} />
          <Route path="/collections/:categorySlug/:vehicleSlug" element={<VehicleDetailsPage />} />

       
          <Route path="*" element={<PageNotFound />} />
 

        </Routes>
        </HelmetProvider>
      </main>

      
      <Footer />
    </div>
  );
}

export default App;
